var _get = require('lodash.get');
var ajax = require('../../utils/ajax');
var getCsrfFromDom = require('../../utils/get-csrf-from-dom');
var tracking = require('../../utils/tracking');
var followActions = require('../../utils/constants').followActions;
var createUniqueId = require('../../utils/create-unique-id');
var getCsrfFromHelper = require('../../utils/csrf-from-helper');

var normalizeConfig = function(input) {
    var output = input;

    output.classes = ['follow-ebay'];

    if (input.class) {
        output.classes.push(input.class);
    }
    if (input.ariaDescribedby) {
        output.ariaDescribedby = input.ariaDescribedby;
    }
    if (input.fakeLink) {
        output.classes.push('follow-ebay-fakeLink');
        output.classes.push('nounderline');
    }

    if (input.pillsButton) {
        output.classes.push('fol-pills-button');
    }

    if (input.blackButton) {
        output.classes.push('black-button');
    }

    return output;
};

module.exports = {
    onMount: function() {
        var self = this;
        var data = this.state.data;
        var url = this.retrieveCallToActionUrl(data);
        var uniqueIdentifier = data.uniqueIdentifier ? data.uniqueIdentifier : '';

        document.addEventListener('follow-auto-apply'
            + createUniqueId(url) + uniqueIdentifier, function(e) {
            if (e.detail) {
                e.preventDefault();
                self.startFollow(e.detail.token);
            }
        });

        this.followStateUniqueIdentifier = createUniqueId(url) + uniqueIdentifier;
        if (this.activeSync) {
            document.addEventListener('follow-state-update' + this.followStateUniqueIdentifier, (event) => {
                let stateDetails = _get(event, 'detail.stateDetails', {});
                if (!this.selfTriggered) {
                    this.setState(stateDetails);
                }
                this.selfTriggered = false;
            });
        }
    },

    onCreate: function() {
        this.state = {
            disabled: false,
            errorData: '',
            errorShow: false,
            data: {}
        };
    },

    onInput: function(input) {
        if (input.config) {
            this.state.data = input.config;
        }
        this.activeSync = input.activeSync;
        return normalizeConfig(input);
    },

    setSyncState: function(name, value) {
        this.setState(name, value);
        let data = {};
        if (typeof name === 'object') {
            data = name;
        } else {
            data[name] = value;
        }

        // ONLY dispatch Custom Event for other components to sync if it's flagged for activeSync
        if (this.activeSync) {
            document.dispatchEvent(new CustomEvent('follow-state-update' + this.followStateUniqueIdentifier, {
                detail: {
                    stateDetails: data
                }
            }));
        }
    },

    ajaxHandler: function(response) {
        this.redirectToLogin(response);
        if (response && response.status === 'success') {
            var newData = this.state.data;
            newData.initialState = (this.state.data.initialState === 'OFF') ? 'ON' : 'OFF';
            if (this.state.data.onCallToAction !== {}) {
                this.setSyncState({
                    data: newData,
                    disabled: false
                });
            }

            var moduleFragments = _get(response, 'model.moduleFragments.FOLLOW', undefined);
            if (moduleFragments !== undefined) {
                this.setSyncState({
                    data: moduleFragments,
                    disabled: false
                });
            }

            if (this.input.scrollOnSave && !this.isInViewport(this.el)) {
                this.el.scrollIntoView();
                this.input.scrollOnSave = false;
            }

            setTimeout(() => {
                var fComp = this.getEl().querySelector('.follow-ebay');
                if (fComp) {
                    fComp.focus();
                }
            });
        } else {
            const errorMessage = _get(response, 'errorData[0].longMessage', '');
            if (errorMessage) {
                this.setState({
                    errorData: errorMessage,
                    errorShow: true
                });
            }
            setTimeout(() => {
                var fComp = this.getEl().querySelector('.tourtip__overlay .tourtip__close');
                if (!fComp) {
                    fComp = this.getEl().querySelector('.follow-ebay');
                }
                if (fComp) {
                    fComp.focus();
                }
            }, 100);
        }
        this.setSyncState('disabled', false);
        this.emit('ajax-response', response);
    },

    startFollow: function() {
        this.input.scrollOnSave = true;
        this.handleClick();
    },

    isInViewport: function(element) {
        var rect = element.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    },

    getTrackingAttribute: function() {
        var trackingAttribue = {};
        var followEbayComp = this.getEl().querySelector('.follow-ebay');
        if (followEbayComp) {
            trackingAttribue = followEbayComp.getAttribute('data-foltrack');
        }
        return trackingAttribue;
    },

    handleClick: function() {
        this.setSyncState('disabled', true);
        this.selfTriggered = true;
        tracking.pulsar(this.getTrackingAttribute());
        var data = this.state.data;
        var csrf;
        if (data.currentState) {
            csrf = data.currentState === 'FOLLOW' ?
                getCsrfFromDom(followActions.followExp) : getCsrfFromDom(followActions.unfollowExp);
        } else {
            csrf = data.initialState === 'OFF' ?
                getCsrfFromDom(followActions.followExp) : getCsrfFromDom(followActions.unfollowExp);
        }

        var url = this.retrieveCallToActionUrl(data);

        ajax({
            errorCallback: this.ajaxHandler.bind(this),
            successCallback: this.ajaxHandler.bind(this),
            url: url + '&srt=' + csrf
        });
    },

    redirectToLogin: function(response) {
        var data = this.state.data;
        if (!this.input.noLogin) {
            if (_get(response, 'status') === 'error' && _get(response, 'code') === 'follow.exp.error.signin') {
                var actionUrl = this.retrieveCallToActionUrl(data);
                var url = new URL(response.errorData.redirectUrl);
                var redirectUrl = new URL(response.errorData.returnUrl);
                redirectUrl.hash = '#fol' + getCsrfFromHelper()
                    + createUniqueId(actionUrl);
                url.searchParams.append('ru', redirectUrl.toString());
                document.location.href = url.toString().replace('SignIn=&', 'SignIn&');
            }
        }
    },

    retrieveCallToActionUrl: function(data) {
        var url;
        if (data.currentState) {
            url = data.stateToActionMap[data.currentState].callToAction.action.URL;
        } else {
            url = data.initialState === 'ON' ? data.onCallToAction.action.URL : data.offCallToAction.action.URL;
        }
        return url;
    },

    handleTooltipCollapse: function() {
        this.setState('errorShow', false);
        setTimeout(() => {
            var fComp = this.getEl().querySelector('.follow-ebay');
            if (fComp) {
                fComp.focus();
            }
        });
    }
};
